'use client';

import React from 'react';
import Card from '@ui/Card';
import PostType, { CampaignType } from 'constants/postType.constants';
import CelebrationPostBody from './CelebrationPostBody';
import FundraiserPostBody from './FundraiserPostBody';
import InKindFundraiserPostBody from './InKindFundraiserPostBody';
import TwitterPostBody from './TwitterPostBody';
import UserPostBody from './UserPostBody';
import VolunteeringPostBody from './VolunteeringPostBody';
import ProjectPostBody from './ProjectPostBody';
import CrowdFundingPostBody from './CrowdFundingPostBody';

const getPostComponent = (post, type, home, orgSlug) => {
  const { sourcePostType } = post;
  switch (sourcePostType) {
    case PostType.UserPost:
      return (
        <UserPostBody post={post} type={type} home={home} orgSlug={orgSlug} />
      );
    case PostType.Campaign:
      if (post.sourcePostData.campaignType === CampaignType.FundRaise) {
        return (
          <FundraiserPostBody
            post={post}
            type={type}
            home={home}
            orgSlug={orgSlug}
            fundRaiseType={post.sourcePostData.fundRaiseType}
          />
        );
      }
      return (
        <InKindFundraiserPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    case PostType.Celebration:
      return (
        <CelebrationPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    case PostType.Volunteering:
      return (
        <VolunteeringPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    case PostType.NewsFeeds:
      return (
        <TwitterPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    case PostType.Project:
      return (
        <ProjectPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    case PostType.CrowdFunding:
      return (
        <CrowdFundingPostBody
          post={post}
          type={type}
          home={home}
          orgSlug={orgSlug}
        />
      );
    default:
      return null;
  }
};

function Post(props) {
  const { post, style, orgSlug = null, type = '', home = false } = props;

  return (
    <Card padding="none" style={style}>
      {getPostComponent(post, type, home, orgSlug)}
    </Card>
  );
}

export default Post;
